function mgAnchor() {
	try {

	} catch (err) {console.log("mgAnchor");}
}
